/* unplugin-vue-components disabled */import script from "./ChatExport.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatExport.vue?vue&type=script&setup=true&lang=js"

import "./ChatExport.vue?vue&type=style&index=0&id=21be3c24&lang=stylus"

const __exports__ = script;

export default __exports__